import React from "react";
import { Grid, TextField, FormControlLabel, Switch } from "@material-ui/core";
import Dropdown from "../../../../../ui_utilities/Dropdown";

/**
 * Chart control panel with enable/disable, width selection, and preview
 */
const ChartControlPanel = ({
  chartNumber,
  chartName,
  chartId,
  chartValue,
  chartWidth,
  onEnableChange,
  onWidthChange,
  onPreviewClick,
}) => {
  return (
    <Grid container spacing={2} className="reporting-chart-controls top-border">
      <Grid item xs={8}>
        <label className="form-label">Chart {chartNumber}</label>
      </Grid>
      <Grid item xs={4} style={{ textAlign: "right" }}>
        <span
          onClick={onPreviewClick}
          className="link-preview-graph"
          style={{ cursor: "pointer" }}
        >
          Preview
          <i className="ag-icon ag-icon-insert-chart"></i>
        </span>
      </Grid>
      <Grid item xs={6}>
        <TextField
          variant="outlined"
          className="text-field-root"
          type="text"
          value={chartName === "Test Day Milk" ? "Milk Production" : chartName}
          InputProps={{
            readOnly: true,
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <Dropdown
          handler={onWidthChange}
          value={chartWidth}
          data={{
            className: "drop-down-root required-style",
            label: "Select a Width",
            name: "graphwidth",
            id: "graphwidth",
            options: [
              {
                name: "Full Page",
                value: "full_page",
              },
              {
                name: "Half Page",
                value: "half_page",
              },
              {
                name: "One Third of a Page",
                value: "one_third",
              },
            ],
          }}
        />
      </Grid>
      <Grid item xs={2} className="chart-actions">
        <FormControlLabel
          style={{ marginTop: "15px", marginLeft: "1px" }}
          control={
            <Switch
              id={chartId}
              size="small"
              value={chartValue}
              checked={chartValue}
              onChange={(event) =>
                onEnableChange(chartId, event.target.checked)
              }
            />
          }
          label="Enable chart"
        />
      </Grid>
    </Grid>
  );
};

export default ChartControlPanel;
